import React from 'react'
import Header from './Header'
import logo from './Assets/about1.png'
export default function About(props) {
  return (
    <div>
      <Header img={logo} title= 'Why Join the Best IELTS and PTE' htitle1="Institute" htitle2="of" htitle3="Barnala?" titletext1="Here at DPD Institute, We focus on quality not on quantity. As a result, we have separate small batches for students. So, that we can focus more on student’s weak areas and help them to overcome from that." titletext3="Experience of over 15+ Years in IELTS and PTE. We are recognized as the best IELTS Institute and PTE Institute in the Barnala region."/>
    </div>
  )
}
